import type { DictionaryData } from './types';

import { SOURCE_DICTIONARY_KEY_FOR_WEBLATE_KEY } from '../../../bin/translations/constants';

function isUseTranslationData(data: unknown): data is DictionaryData {
  return data instanceof Object && SOURCE_DICTIONARY_KEY_FOR_WEBLATE_KEY in data;
}

export default isUseTranslationData;
